export enum Columns {
  Type = 'type',
  Status = 'status',
  Trigger = 'trigger',
  Frequency = 'frequency',
}
